import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom'
import { MenuContext } from './context/menuContext'

const POSICION_MENU_FAVORITOS = 2

const MenuFavoritos = () => {
  const { menus } = useContext(MenuContext)

  return (
    <>
      {menus
        .filter((menu) => menu.idMenuPosicion === POSICION_MENU_FAVORITOS)
        .map((menuFavorito) => (
          <div key={menuFavorito.idMenu}>
            <NavLink to={`/${menuFavorito.link}`} className="acceso-directo">
              {menuFavorito.nombre}
            </NavLink>
          </div>
        ))}
    </>
  )
}

export default React.memo(MenuFavoritos)
